import React from 'react';
//import { useState, useEffect } from 'react';
import DBTable from '../../components/dbTable.jsx';
import './table-view.css'
//import director from '../../director';
//import { object } from 'underscore';
const TableViewTemplate=({container})=>{
    container.fetchUserTable();
    container.fetchFeaturesTable();
    
    return (
        <div className={"table-display"}>
            <div className="table-container">
                <DBTable
                    fetchTable={container.getUserTable}
                    iTable={[]}
                    edit={true}
                    hasNew={true}
                    getUserInfo={container.getUserInfo}
                    tableHeader={["Usuario", "Password", "Instalaciones"]}
                    tableColumns={["user","pass","install_qty"]}
                    managerOn={container.on}
                    managerOff={container.off}
                    title={"Usuarios"}
                    newFunction={container.newUser}
                    deleteFunction={container.deleteUser}
                    updateFunc={container.updateUserInfo}
                    deleteSlot={container.deleteSlot}/>
            </div>
            <div className="table-container">
            <DBTable
                fetchTable={container.getFeaturesTable}
                iTable={[]}
                edit={false}
                hasNew={true}
                tableHeader={["Id"]}
                tableColumns={["code"]}
                managerOn={container.on}
                managerOff={container.off}
                newFunction={container.newFeature}
                deleteFunction={container.deleteFeature}
                title={"Características"}/>
            </div>
        </div>
        
    )
}
export default TableViewTemplate;